import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/RegisterInterest" );

/* eslint-disable arrow-body-style */

/**
 * Get data to be used in the price on application modal
 */
export const getModalData = () => {
  return instance.get( "GetModalData" );
};

/**
 * Save data when the price on application modal is saved
 * @param {Number} productId The product ID to use
 * @param {object} modalData Contents of the modal dialog
 */
export const save = ( productId, modalData ) => {
  return instance.post( "Save", modalData, {
    productId
  } );
};
